(() => {
  window.addEventListener('load', () => {
    console.log('Select');
    const selects = document.querySelectorAll('.form__field--select');
    selects.forEach((select) => {
      select.querySelector('select').addEventListener('focus', () => {
        select.classList.add('open');
      });
      select.querySelector('select').addEventListener('blur', () => {
        select.classList.remove('open');
      });
    });
  });
})();
